import GpsStampHistoryLayout from './GpsStampHistoryLayout';

export default GpsStampHistoryLayout;
